module.exports = __webpack_public_path__ + "img/e2c97d7.jpg";